module.exports = __webpack_public_path__ + "img/entp.1d3086ad.png";